export default __webpack_public_path__ + "static/media/link.dfa3da67.svg";